<div class="mail-link-bloc login-bloc">

  <div class="row" (click)="toggleCollapse()">
    <div class="logo">
      <i class="fa fa-fw fa-envelope-o"></i>
      <i class="fa fa-magic"></i>
    </div>
    <div class="content">
      <h2>Login via mail</h2>
    </div>
  </div>

  <div class="details" [@collapsed]="collapsed$ | async" *ngIf="(collapsed$ | async)!=null">

    <p *ngIf="waitingForMail">
      Entrez votre adresse email, et cliquez sur le lien qui vous sera envoyé
    </p>
    <form #contactMailForm="ngForm" [hidden]="!waitingForMail"
          (ngSubmit)="onSubmit(contactMailForm.valid);">

      <div class="row">
        <input type="email" pInputText
               name="contactMail"
               placeholder="Adresse email"
               required
               [disabled]="validating$ | async"
               [(ngModel)]="contactMail">

        <input type="submit" hidden>
        <a class="lifeislife-button-link"
           title="Envoyer" i18n-title
           [class.disabled]="contactMailForm.invalid || (validating$ | async)"
           (click)="onSubmit(contactMailForm.valid);">
          <!--        <i class="fa fa-envelope-o"></i>-->
          <span>Envoyer</span>
        </a>
      </div>

      <div class="action">

      </div>

      <span class="validating-message" *ngIf="validating$ | async">
        Vérification...
      </span>
    </form>


    <div *ngIf="completed">
      <div *ngIf="mailSent === true; else mailNotSent">
        <p>
          Un lien a été envoyé à {{ contactMail }}. Utilisez-le pour vous connecter.
        </p>
        <!--          <a class="lifeislife-button-link"-->
        <!--             title="Fermer la page" i18n-title-->
        <!--             (click)="onCloseClick();">-->
        <!--            <span>Fermer la page</span>-->
        <!--          </a>-->
      </div>

      <ng-template #mailNotSent>
        <p>
          L'email n'a pas pu être envoyé. Vérifiez que c'est bien celui correspondant à votre compte utilisateur.
        </p>

        <p *ngIf="errorMessage" class="error">
          Message d'erreur: {{ errorMessage }}
        </p>
      </ng-template>

    </div>
  </div>
</div>
